import Vue from 'vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

Vue.use(datePicker);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/datepicker.js